
let pendingReads = 0
const pendingEndpoints = new Map()
const pendingOperations = new Map()
let revision = 0
let localIndicators = 0
const listeners = new Set()
const notify = () => { revision += 1; listeners.forEach(listener => listener()) }

// Document generation/downloads retain their own progress indicators.
const downloadEndpoints = new Set(['fetchInvoiceAllocationPdfs', 'fetchWorkerPayrollReport'])
export const isInformationRequest = endpoint => (
    (String(endpoint).startsWith('fetch') && !downloadEndpoints.has(endpoint))
    || endpoint === 'organisations'
    || endpoint === 'lookupAbn'
)

export function beginInformationRequest(endpoint) {
    if (!isInformationRequest(endpoint)) {
        pendingOperations.set(endpoint, (pendingOperations.get(endpoint) || 0) + 1)
        notify()
        let finished = false
        return () => { if (!finished) { finished = true; pendingOperations.set(endpoint, Math.max(0, (pendingOperations.get(endpoint) || 0) - 1)); notify() } }
    }
    pendingReads += 1
    pendingEndpoints.set(endpoint, (pendingEndpoints.get(endpoint) || 0) + 1)
    notify()
    let finished = false
    return () => {
        if (finished) return
        finished = true
        pendingReads -= 1
        pendingEndpoints.set(endpoint, Math.max(0, (pendingEndpoints.get(endpoint) || 0) - 1))
        notify()
    }
}

export function registerLocalIndicator() {
    localIndicators += 1
    notify()
    let removed = false
    return () => {
        if (removed) return
        removed = true
        localIndicators -= 1
        notify()
    }
}

export const getInformationLoading = () => pendingReads > 0 && localIndicators === 0
export const subscribeInformationLoading = listener => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export const getLoadingRevision = () => revision
export const hasPendingInformation = () => pendingReads > 0
export const hasPendingRequests = endpoints => endpoints.some(endpoint => (pendingEndpoints.get(endpoint) || 0) > 0)

export const getOperationMessage = () => {
    const endpoint = [...pendingOperations.keys()].find(key => pendingOperations.get(key) > 0)
    if (!endpoint) return ''
    if (/send|email|sms/i.test(endpoint)) return 'Sending…'
    if (/delete|remove/i.test(endpoint)) return 'Deleting…'
    if (/generate|preview|report|pdf/i.test(endpoint)) return 'Generating…'
    if (/save|update|create/i.test(endpoint)) return 'Saving…'
    return 'Processing…'
}
